import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

import { Page } from './models/page.model';
import { PageProperties } from './models/page-properties.model';

const defaultProps: PageProperties = {
  disabled: false,
  hidePageSize: false,
  pageSizeOptions: [5, 10, 15],
  showFirstLastButtons: true,
  hideRange: false,
};

@Component({
    selector: 'seds-paginator',
    templateUrl: './seds-paginator.component.html',
    styleUrls: ['./seds-paginator.component.scss'],
    standalone: false
})
export class SedsPaginatorComponent implements OnInit, OnChanges, OnDestroy {
  @Input() page?: Page;
  @Input() set props(props: PageProperties) {
    this._props = { ...this._props, ...props };
  }

  @Output() setPage: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
  @Output() setPaginator: EventEmitter<MatPaginator> = new EventEmitter<MatPaginator>();
  @ViewChild('paginator', { static: true })
  paginator!: MatPaginator;
  _props: PageProperties = defaultProps;

  ngOnInit() {
    this.paginator.page.subscribe(_page => {
      this.setPage.emit(_page);
    });
    this.setPaginator.emit(this.paginator);
  }

  ngOnChanges() {
    this.setPaginatorState();
  }

  setPaginatorState() {
    if (!this.page) {
      return;
    }
    this.paginator.length = this.page.length;
    this.paginator.pageIndex = this.page.pageIndex;
    this.paginator.pageSize = this.page.pageSize;
  }

  ngOnDestroy(): void {
    this.paginator.page.unsubscribe();
  }
}
